/**
 * Client-side tool registry: tool id → lazily loaded React component.
 * Keep in step with registry.server.ts.
 */
import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { ToolProps } from '../src/lib/toolkit';
import { PLACEHOLDERS } from './placeholders';

const Placeholder = lazy(() => import('../src/pages/Placeholder'));

export const TOOL_CLIENTS: Record<string, LazyExoticComponent<ComponentType<ToolProps>>> = {
  ...Object.fromEntries(PLACEHOLDERS.map((p) => [p.id, Placeholder])),
  'recommended-assets': lazy(() => import('./recommended-assets/client')),
  'blueprint-tracker': lazy(() => import('./blueprint-tracker/client')),
  orbat: lazy(() => import('./orbat/client')),
  'tsc-requests': lazy(() => import('./tsc-requests/client')),
  'org-assets': lazy(() => import('./org-assets/client')),
  'our-org': lazy(() => import('./our-org/client')),
  calendar: lazy(() => import('./calendar/client')),
  events: lazy(() => import('./events/client')),
  attendance: lazy(() => import('./attendance/client')),
  alerts: lazy(() => import('./alerts/client')),
  'combined-arms': lazy(() => import('./combined-arms/client')),
  'management-requests': lazy(() => import('./management-requests/client')),
  analytics: lazy(() => import('./analytics/client')),
  'tsc-unit': lazy(() => import('./tsc-unit/client')),
  'racing-unit': lazy(() => import('./racing-unit/client')),
  'your-management': lazy(() => import('./your-management/client')),
  'freelancer-unit': lazy(() => import('./freelancer-unit/client')),
  'academy-unit': lazy(() => import('./academy-unit/client')),
  'my-academy': lazy(() => import('./my-academy/client')),
  'academy-management': lazy(() => import('./academy-management/client')),
  'academy-mentors': lazy(() => import('./academy-mentors/client')),
};

/** Client for tools generated from a template (manifest.template). */
export const TEMPLATE_CLIENTS: Record<string, LazyExoticComponent<ComponentType<ToolProps>>> = {
  unit: lazy(() => import('./unit/client')),
  rules: lazy(() => import('./rules/client')),
  page: lazy(() => import('./rules/client')),
  course: lazy(() => import('./course/client')),
};
